import { createApp } from 'vue'

import App from './App.vue'
// import Cookies from 'js-cookie'
import router from './router/index'
// import store from "./store/index";
import loading from './ui/loading'
import toast from './ui/toast'
// import modules from "./third";
// import report from './libs/report'
import VConsole from 'vconsole'

import './assets/scss/global.scss'
import './assets/scss/iconfont.scss'
import './assets/scss/rem.scss'
import { setTheme } from './utils/theme'
const app = createApp(App)
app.use(router)

setTheme()
// router.isReady().then(() => app.mount('#app'))

// app.use(store);

toast.provide(app)
loading.provide(app)
loading.directive(app)

if (
  import.meta.env.VITE_APP_MODE === 'test' ||
  import.meta.env.VITE_APP_MODE === 'dev'
) {
  // eslint-disable-next-line
  new VConsole({ theme: "dark" });
}

Object.assign(window, {
  // $login: modules.login,
  // $actionUrl: modules.actionUrl,
  // $pay: modules.pay,
  // $utils: modules.utils,
  // $report: report,
  // $ddl: modules.ddl,
})

app.mount('#app')

console.log('main.js current-data====', new Date())

if (document.getElementById('indexLoading')) {
  document.getElementById('indexLoading').remove()
}

// const allCookies = Cookies.get()
